module.exports = __webpack_public_path__ + "static/media/5.03bf7338.gif";